import { render, staticRenderFns } from "./CustomerDetailActionBar.vue?vue&type=template&id=0a96c92e&scoped=true&"
import script from "./CustomerDetailActionBar.vue?vue&type=script&lang=js&"
export * from "./CustomerDetailActionBar.vue?vue&type=script&lang=js&"
import style0 from "./CustomerDetailActionBar.vue?vue&type=style&index=0&id=0a96c92e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a96c92e",
  null
  
)

export default component.exports